import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";

export default function Slideshow({ images, width = 633, height = 310, interval = 2000 }: { images?: string[]; width?: number; height?: number; interval?: number }){
	const list = Array.isArray(images) ? images.filter(Boolean) : [];
	const [index, setIndex] = useState(0);

	useEffect(() => {
		if (list.length < 2) return;
		const timer = window.setInterval(() => setIndex((i) => (i + 1) % list.length), interval);
		return () => window.clearInterval(timer);
	}, [list.length, interval]);

	if (!list.length) return null;

	return <Box sx={{ position: "relative", width: `${width}px`, maxWidth: "100%", height: `${height}px`, overflow: "hidden" }}>
		{list.map((src, i) => (
			<img key={src + i} src={src} alt="" width={width} height={height}
				style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: i === index ? 1 : 0, transition: "opacity .8s" }} />
		))}
	</Box>;
}
